import R from "ramda";
import { http } from "./http";

export const fetchCategories = (accountId) => (
  http.get(`/accounts/${accountId}/categories`)
    .then(response => {
      const categories = R.pathOr([], ["data", "categories"], response);
      return { categories, response };
    })
);

export const createCategory = (accountId, data) => (
  http.post(`/accounts/${accountId}/categories`, { name: data })
);

export const deleteIncludeRule = (accountId, categoryId, ruleId) => (
  http.delete(`/accounts/${accountId}/categories/${categoryId}/rules/vendors/${ruleId}`)
);

export const deleteCategories = (accountId, selectedCategoryIds) => {
  const ajaxPromises = selectedCategoryIds.map(id => (
    http.delete(`/accounts/${accountId}/categories/${id}`)
  ));
  return Promise.all(ajaxPromises);
};

export const saveCategory = (accountId, category) => (
  http.put(`/accounts/${accountId}/categories/${category.id}`, category)
);

export const createIncludeRules = (accountId, categoryId, newRules) => {
  const ajaxPromises = newRules.map(rule => {
    const newRule = R.clone(rule);
    newRule.vendorName = rule.name || rule.vendorName;
    newRule.action = "include";
    return http.post(`accounts/${accountId}/categories/${categoryId}/rules/vendors`, newRule);
  });
  return Promise.all(ajaxPromises);
};



// WEBPACK FOOTER //
// ./src/js/api/categories.js